<template>
  <form @submit.prevent="onSubmit">
    <div class="card user-form">
      <header class="card-header has-background-grey-lighter">
        <p class="card-header-title has-text-black">
          <span v-if="user">{{ user.firstName }}</span>
          <span v-else>CREATE USER</span>
        </p>
        <div class="buttons">
          <template  v-if="user">

            <b-button
            size="is-small"
            :loading="teleporting == user.id"
            :disabled="user.id == $store.state.Auth.user.id || user.archivedAt"
            @click="teleport(user.id)"
            v-if="canTeleportAs(user)" >TELEPORT</b-button>

            <b-button
              size="is-small"
              @click="restore"
              :loading="restoring"
              v-if="user.archivedAt"
            >RESTORE</b-button>
            <b-button
              size="is-small"
              type="is-warning"
              :loading="archiving"
              @click="archive"
              v-else
            >ARCHIVE</b-button>
            <b-button
              size="is-small"
              type="is-danger"
              :loading="deleting"
              @click="onRemove"
              v-if="isSuperAdmin"
            >DELETE</b-button>
            <b-button
              size="is-small"
              :loading="forgetting"
              @click="forgotPassword"
              v-if="isSuperAdmin"
            >RESET PASSWORD</b-button>
          </template>
          <b-button size="is-small" @click="$emit('close')">CLOSE</b-button>
        </div>
      </header>
      <div class="card-content scrollable" :style="{ height: `${scrollableHeight}px` }">
        <b-tabs>
          <b-tab-item label="Details">
            <b-field label="First Name">
              <b-input v-model="form.firstName"></b-input>
            </b-field>
            <!-- <b-field label="Last Name">
              <b-input v-model="form.lastName"></b-input>
            </b-field> -->
            <b-field label="Email">
              <b-input v-model="form.email" type="email"></b-input>
            </b-field>
            <b-field label="Mobile">
              <b-input v-model="form.mobile"></b-input>
            </b-field>
            <b-field>
              <b-checkbox
                v-model="form.emailPasswordLink"
                :disabled="!validEmail"
                :true-value="1"
                :false-value="0"
              >Email Password Link</b-checkbox>
            </b-field>
            <tags-input label="Tags" allow-new :values.sync="form.tags" />
            <div class="field">
              <label class="label">Permitted Orders</label>
              <div class="control is-clearfix" v-for="(tag, index) in tags" :key="index">
                <b-checkbox :native-value="tag.name" v-model="form.tags">{{ tag.name }}</b-checkbox>
              </div>
            </div>
          </b-tab-item>
          <b-tab-item label="Permissions">
            <rolesAndPermissions
              :checked.sync="form.permissions"
              :checked-roles.sync="form.roles"
              :ishaveValue="form.email ? true : false"
            />
            <!-- <permission-checkboxes
                            :checked.sync="form.permissions"
                            :params="{ type: 'user' }"
                            v-if="canManageUsers"
            />-->
          </b-tab-item>
          
          <b-tab-item label="Documents">
              <!-- <list-documents 
                :model="user" 
                modelType="person"  /> -->
              <file-list 
                :model="user" 
                modelType="person"
              />
          </b-tab-item>


        </b-tabs>
      </div>
      <footer class="card-footer">
        <b-button
          class="is-fullwidth"
          native-type="submit"
          type="is-link"
          :loading="loading"
          :disabled="!user ? !canManageUsers : false"
        >
          <span v-if="user">UPDATE</span>
          <span v-else>CREATE</span>
        </b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import PermissionCheckboxes from "@/components/Permission/PermissionCheckboxes";
import rolesAndPermissions from "./rolesAndPermissions";
import Roles from "@/helpers/roles";
import { AuthService } from "@/services/auth.service";
import { UserService } from "@/services/user.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import { TagService } from "@/services/tag.service";
import ListDocuments from "@/components/Documents/ListDocuments";
import FileList from "@/components/File/FileList";
import TagsInput from "@/components/partials/TagsInput";
import { startRouteMixin } from "@/mixins/startRouteMixin";

import { RoleService } from "@/services/role.service";


import Permissions from "@/helpers/permissions";

export default {
  props: {
    organizationId: {
      type: Number | String,
      required: true
    },
    user: {
      type: Object
    },
    height: {
      type: Number,
      default: 0
    }
  },
  components: {
    PermissionCheckboxes,
    rolesAndPermissions,
    ListDocuments,
    FileList,
    TagsInput
  },
  
  mixins: [startRouteMixin],

  data: () => ({
    authService: AuthService,
    userService: UserService,
    tagService: TagService,
    form: {
      firstName: "",
      // lastName: "",
      email: "",
      mobile: "",
      hasMobileApplication: 0,
      hasEmailNotification: 0,
      hasSmsNotification: 0,
      isActive: 1,
      permissions: [],
      roles: [],
      tags: [],
      emailPasswordLink: null
    },
    validEmail: false,
    loading: false,
    archiving: false,
    restoring: false,
    deleting: false,
    forgetting: false,
    containerHeight: 0,
    tags: [],
    teleporting: null,

  }),
  computed: {
    scrollableHeight() {
      return this.height - 86 - 76; // header height, footer height
    },
    isSuperAdmin() {
      return this.$store.getters["Auth/hasRole"](Roles.SUPERADMIN);
    },
    canManageUsers() {
      return this.$store.getters["Auth/hasPermission"]("can manage users");
    },

    canViewDocuments() {

      return this.$store.getters["Auth/hasPermission"]("can view documents");

    },

  },
  watch: {
    "form.email"(value) {
      var re = /\S+@\S+\.\S+/;
      this.validEmail = re.test(value);
    },
    user: {
      handler(user) {
        if (user) {
          this.fillData(user);
        } else {
          this.resetForm();
        }
      },
      deep: true
    }
  },
  mounted() {
    this.getTags();
    if (this.user) {
      this.$nextTick(() => {
        this.fillData(this.user);
      });
    }else{

      if (!this.isSuperAdmin) { return false; }

      RoleService.all({includes: 'permissions'}).then(response => {

        let data = JsonDenormalizer.denormalize(response);

        data = data.filter(role => {

          return role.name.toLowerCase() == 'administrator';
          // return role.name.toLowerCase() == 'admin';

        });

        this.form.roles = data.map(a => a.id);


        if (data.length) {

          let permissionIds = [];

          data[0].permissions.forEach(permission => {

            permissionIds.push(permission.id);

          });

          this.form.permissions = permissionIds;

        }

      });


    }
  },
  methods: {
    fillData(user) {
      // console.log(user);
      this.form = {
        firstName: user.firstName,
        // lastName: user.lastName,
        email: user.email || "",
        mobile: user.mobile || "",
        hasMobileApplication: user.groupIdApp,
        hasEmailNotification: user.orderRecipient,
        hasSmsNotification: user.orderRecipientSms,
        isActive: user.active ? 1 : 0,
        // permissions:
        //   this.canManageUsers && user.permissions
        //     ? user.permissions.map(permission => permission.id)
        //     : [],

        permissions: user.permissions ? user.permissions.map(permission => permission.id) : [],
        
        roles:
          user.roles
            ? user.roles.map(role => role.id)
            : [],
        tags: user.tags ? user.tags.map(tag => tag.name) : []
      };
    },
    async getTags() {
      const tags = await this.tagService
        .all({ type: "[SYSTEM][ACCESS][ORDERS]", includes: "tags" })
        .then(response => JsonDenormalizer.denormalize(response));

      if (tags.length) {
        this.tags = tags[0].tags || [];
      }
    },
    transformedData() {
      return {
        admin: true,
        first_name: this.form.firstName,
        // last_name: this.form.lastName,
        email_address: this.form.email,
        mobile_number: this.form.mobile,
        group_id_app: this.form.hasMobileApplication,
        order_recipient: this.form.hasEmailNotification,
        order_recipient_sms: this.form.hasSmsNotification,
        active: this.form.isActive,
        firm_id: this.organizationId,
        permission_ids: this.form.permissions,
        role_ids: this.form.roles,
        tags: this.form.tags,
        emailPasswordLink: this.form.emailPasswordLink
      };
    },
    resetForm() {
      this.form = {
        firstName: "",
        // lastName: "",
        email: "",
        mobile: "",
        hasMobileApplication: 0,
        hasEmailNotification: 0,
        hasSmsNotification: 0,
        isActive: 1,
        permissions: [],
        roles: [],
        tags: []
      };
    },
    onSubmit() {
      if (this.user) {
        this.update();
      } else {
        this.create();
      }
    },
    async create() {
      this.loading = true;

      try {
        await this.userService.store(this.transformedData());

        this.$buefy.toast.open({
          message: "User has been created.",
          type: "is-info",
          position: "is-top-right"
        });
        this.resetForm();
        this.$emit("create-success");
      } catch (err) {}

      this.loading = false;
    },
    async update() {
      this.loading = true;

      try {
        const response = await this.userService.update(this.user.id, {
          ...this.transformedData(),
          includes: "permissions,roles,tags"
        });
        const user = JsonDenormalizer.denormalize(response);

        this.$buefy.toast.open({
          message: "User has been updated.",
          type: "is-info",
          position: "is-top-right"
        });
        this.$emit("update-success", user);
      } catch (err) {}

      this.loading = false;
    },
    async archive() {
      this.archiving = true;

      try {
        const response = await this.userService.archive(this.user.id, {
          includes: "permissions,roles"
        });
        const user = JsonDenormalizer.denormalize(response);

        this.$buefy.toast.open({
          message: "User has been archived.",
          type: "is-info",
          position: "is-top-right"
        });
        this.$emit("archive-success", user);
      } catch (err) {}

      this.archiving = false;
    },
    async restore() {
      this.restoring = true;

      try {
        const response = await this.userService.restore(this.user.id, {
          includes: "permissions,roles"
        });
        const user = JsonDenormalizer.denormalize(response);

        this.$buefy.toast.open({
          message: "User has been restored.",
          type: "is-info",
          position: "is-top-right"
        });
        this.$emit("restore-success", user);
      } catch (err) {}

      this.restoring = false;
    },
    onRemove() {
      this.$buefy.dialog.confirm({
        title: "Confirm",
        message: "Are you sure you want to <b>delete</b> this user?",
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.remove();
        }
      });
    },
    async remove() {
      this.deleting = true;

      try {
        await this.userService.delete(this.user.id);

        this.$buefy.toast.open({
          message: "User has been deleted.",
          type: "is-info",
          position: "is-top-right"
        });
        this.$emit("remove-success", this.user.id);
      } catch (err) {}

      this.deleting = false;
    },
    async forgotPassword() {
      this.forgetting = true;

      try {
        await this.authService.forgotPassword({
          email_address: this.user.email
        });

        this.$buefy.toast.open({
          message: "Credentials has been sent.",
          type: "is-info",
          position: "is-top-right"
        });
      } catch (err) {}

      this.forgetting = false;
    },

    async teleport(id) {
      this.teleporting = id;

      try {
        const token = await this.authService.teleport({id}).then(response => response.data.token);

        this.$store.dispatch("Auth/setToken", token);
        this.navigateToStartRoute();

      } catch (err) {}

      // this.teleporting = null;
    },

    canTeleportAs(user) {
      // return (this.isSuperAdmin
      //   || (this.$store.state.Auth.user.firmId == user.firmId
      //     && this.$store.getters["Auth/hasPermission"](Permissions.CAN_TELEPORT_AS_COLLEAGUE)));
      return this.isSuperAdmin || this.$store.getters["Auth/hasPermission"](Permissions.CAN_TELEPORT_AS_COLLEAGUE);
    }

  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Users/list-new/partials/userForm.vue